import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { rgba } from 'polished';

const checkedStyles = ({ checked }) => {
  if (checked) {
    return css`
      background-color: ${rgba('#000', 0.05)};
      box-shadow: inset 0 1px ${rgba('#000', 0.03)};
    `;
  }

  return css``;
};

const Label = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px;
  background: #fff;
  box-shadow: 0 1px ${rgba('#000', 0.0275)};
  border-radius: 4px;
  border: 1px solid ${rgba('#000', 0.15)};
  user-select: none;
  transition: all 160ms ease;
  
  
  &, input {
    cursor: pointer;
  }

  input {
    margin-right: 8px;
  }

  &:selection {
    background: transparent;
  }

  &:hover:before {
    background: #fcfcfc;
    transition: all 160ms ease;
  }
  
  ${checkedStyles}
`;

const Checkbox = ({
  label,
  id,
  onChange,
  name,
  value,
  type = 'checkbox',
  disabled,
}) => (
  <Label htmlFor={id} checked={value}>
    <input
      id={id}
      type={type}
      name={name}
      checked={value}
      value={value}
      disabled={disabled}
      onChange={onChange}
    />
    { label }
  </Label>
);

export default Checkbox;
